import React from 'react';
import LateralMenu from '../LateralMenu';
import { faCalculator, faPlug, faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_crm.png';
import collapsedLogo from '../../../assets/icon_crm.png';
import { faCameraCctv, faCameraSlash, faSquareKanban } from '@fortawesome/pro-solid-svg-icons';
import { useCurrentApp } from '../../context/CurrentApp';

export default function CrmLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu }: LateralMenuProps) {
    const { isParentApp } = useCurrentApp();

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={[{
                icon: faCameraCctv,
                text: translate('cameras'),
                action: () => navigation.navigate('CRM', { screen: 'Management' }),
                selected: selectedMenu == 'cameras'
            }, {
                icon: faCalculator,
                text: translate('alarmCenters'),
                action: () => navigation.navigate('CRM', { screen: 'AlarmCentersList' }),
                selected: selectedMenu == 'alarm-centers'
            }, {
                icon: faPlug,
                text: translate('offlineEvents'),
                action: () => navigation.navigate('CRM', { screen: 'OfflineEvents' }),
                selected: selectedMenu == 'offline-events'
            }, {
                icon: faSquareKanban,
                text: translate('offlineEventsKanban'),
                action: () => navigation.navigate('CRM', { screen: 'OfflineEventsKanban' }),
                selected: selectedMenu == 'offline-events-kanban',
                omit: !isParentApp,
            }, {
                icon: faScrewdriverWrench,
                text: translate('maintenanceRequests'),
                action: () => navigation.navigate('CRM', { screen: 'MaintenanceRequests' }),
                selected: selectedMenu == 'maintenance-requests'
            }, {
                icon: faCameraSlash,
                text: translate('drpScenarios'),
                action: () => navigation.navigate('CRM', { screen: 'TicketReasons' }),
                selected: selectedMenu == 'ticket-reasons'
            }]}
        />
    );
}
